import { CopyToClipboard, IconButton } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import type { CopyIdActionProps as Props } from './types';

export const CopyIdAction = memo(({ className, item }: Props) => {
  return (
    <CopyToClipboard
      value={item.id}
      messagePrefix="Id"
      component={() => (
        <IconButton
          className={classnames('CopyIdAction', className)}
          icon="copy"
          tooltipTitle="Copy Id"
        />
      )}
    />
  );
});

CopyIdAction.displayName = 'CopyIdAction';
